import { useRef } from "react";
import useClickOutside from "../../hooks/useClickOutside";
import useScrollLock from "../../hooks/useScrollLock";

interface ISideBar {
    onClose: () => void;
    children: React.ReactNode;
    isOpen: boolean;
}

const SideBar = ({ onClose, children, isOpen }: ISideBar) => {
    const sideBarRef = useRef<HTMLDivElement>(null);

    useClickOutside(sideBarRef, onClose);
    useScrollLock(isOpen);

    return (
        <div
            className={`fixed left-0 top-0 z-[2331917] h-dvh w-full duration-500 ease-in-out 
            ${isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        >
            <div
                ref={sideBarRef}
                className={`bg-primary-100 shadow-custom-dual w-4/5 h-full absolute left-0 top-0 
                transition-transform duration-700 ease-in-out
                ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
            >
                {children}
            </div>
        </div>
    );
};

export default SideBar;
